import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { Form, Modal, Button } from "react-bootstrap";
import { Field, reduxForm } from "redux-form";
import { useHistory } from "react-router-dom";
import api from "../../api/projects";
import { useForm } from "react-hook-form";
import {
  listProjects,
  getCategories,
  addProject,
} from "../../actions/projects";

import Loader from "../loader/Loader.component";

import "./Overview.css";
// import history from '../../history';
const user = "6054074f8c41cc4cba4333ef";

const required = (value) => (value ? undefined : "Required");
const columns = [
  {
    name: "Project Name",
    selector: "name",
    sortable: true,
    format: ({ name, _id }) => (
      <span className="project-name">
        <Link to={`/${_id}/summary`}>{name}</Link>
      </span>
    ),
  },
  {
    name: "Created By",
    selector: "user",
    sortable: true,
    format: ({ user_nickname }) => <span>{user_nickname}</span>,
  },
  {
    name: "Status",
    selector: "status",
    sortable: true,
  },
  {
    name: "Date Created",
    selector: "year",
    sortable: true,
    format: (row) => (
      <span>
        {moment.unix(row.date.created).format("MM/DD/YYYY")},&nbsp; (
        {moment(
          moment.unix(row.date.created).format("MMDDYYYY"),
          "MMDDYYYY"
        ).fromNow()}
        )
      </span>
    ),
  },
];

const Overview = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const allProjects = useSelector((state) => state.projects.userProjects);
  const [showAddProjectModal, setShowAddProjectModal] = useState(false);
  const [projectsPending, setProjectsPending] = useState(false);

  useEffect(async () => {
    const results = await api.get("/projects");
    dispatch({ type: "LIST_PROJECTS", payload: results.data });
  }, []);

  const loadProject = ({ _id }) => {
    history.push(`/${_id}/summary`);
  };

  const onAddProjectSubmit = async (formValues) => {
    let projectData = {
      ...formValues,
      _id: user,
      date: {
        created: moment.unix(),
        last_mod: moment.unix(),
      },
      status: "Active",
      collaborators: [],
      collaborators_invitation: [],
    };

    // let projectData = {
    //   // ...form,
    //   compute_region: 'us-east4',
    //   overview: "Sid test" ,
    //   name: "sid t3",
    //   category: null,
    //   account_id: null,
    //   // user_id: '6054074f8c41cc4cba4333ef',
    //   user_id: '70a60cfbd06b676e60c1514aaeec9f06',
    //   user_nickname: "sid",
    //   user,
    //   date: {
    //     created: moment.unix(),
    //     last_mod: moment.unix()
    //   },
    //   status: 'Active',
    //   collaborators: [],
    //   collaborators_invitation: []
    // }

    console.log(projectData);

    await dispatch(addProject(projectData))

    console.log('xd');

    // const project = await api.post(`/projects`, { projectData });
    // console.log(project);
    // dispatch({ type: "ADD_PROJECT", payload: project.data });
    // this.setState({
    //   showAddProjectModal: false
    // })
    // this.props.reset()
  };

  return (
    <>
      <div className="content">
        <div className="boxed_section">
          <div className="boxed_header">
            <h3>
              Projects
              <Link
                to="#"
                className="button interface"
                onClick={() => setShowAddProjectModal(true)}
              >
                Add
              </Link>
            </h3>
            <form className="advanced_search">
              {/* <input
                type="text"
                placeholder="Search"
                value={this.state.searchFilter}
                onChange={this.filterProjects}
              /> */}
              <button type="button">Search</button>
            </form>
          </div>
          {allProjects ? (
            <DataTable
              columns={columns}
              data={allProjects}
              defaultSortField="title"
              pagination
              highlightOnHover
              pointerOnHover
              progressPending={projectsPending}
              onRowClicked={loadProject}
              progressComponent={<Loader />}
            />
          ) : (
            ""
          )}
        </div>
      </div>

      <Modal
        show={showAddProjectModal}
        onHide={() => setShowAddProjectModal(false)}
      >
        <Modal.Header closeButton>
          <h4>Add Project</h4>
        </Modal.Header>
        <form onSubmit={handleSubmit(onAddProjectSubmit)}>
          <Modal.Body>
            <label>
              Name
              <input
                className="form-control"
                name="name"
                id="name"
                type="text"
                {...register("name", { required: true, maxLength: 80 })}
              />
            </label>
            <label>
              Category
              <select
                name="category"
                {...register("category", { required: false })}
              >
                <option value="c1">c1</option>
                <option value="c2">c2</option>
              </select>
            </label>
            <label>
              Compute Region
              <select
                name="compute_region"
                {...register("compute_region", { required: true })}
              >
                <option value="asia-east1">Taiwan</option>
                <option value="asia-northeast1">Tokyo</option>
                <option value="asia-south1">Mumbai</option>
                <option value="asia-southeast1">Singapore</option>
                <option value="australia-southeast1">Sydney</option>
                <option value="europe-west1">Belgium</option>
                <option value="europe-west2">London</option>
                <option value="europe-west3">Frankfurt</option>
                <option value="europe-west-4">Netherlands</option>
                <option value="northamerica-northeast1">Montréal</option>
                <option value="southamerica-east1">São Paulo</option>
                <option value="us-central1">Iowa</option>
                <option value="us-east4">Northern Virginia</option>
                <option value="us-west1">Oregon</option>
              </select>
            </label>
            <label>
              Overview
              <textarea
                className="form-control overview-box"
                name="overview"
                id="overview"
                type="text"
                {...register("overview", { required: false })}
              />
            </label>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-primary"
              type="submit"
              defaultValue="Login"
              data-wait="Please wait..."
            >
              Create Project
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};

export default reduxForm({
  form: "AddProject",
})(Overview);
